module.exports = __webpack_public_path__ + "img/venus19.e5fa38ae.png";